// Hawaii State Parks (Explore Outdoor Hawaiʻi) booking strategy.
//
// Booking URL: passthrough of the static SPA route
// `https://explore.ehawaii.gov/web/#!park/{PlaceId}/{FacilityId}`. Discovery
// (agencies/HawaiiStateParks/pipeline/00-discovery) verified the bare route
// renders the full facility grid and that the hash router accepts no date
// params — users re-pick dates on the page, same as ReserveCalifornia.
//
// Preview URL: the park-level overview (`facility.extraAttributes.parkUrl`,
// `#!park/{PlaceId}`). Multi-facility parks (Kalopa, Wai'anapanapa, Napali
// Coast) have per-site reserveUrls that land on ONE RDR facility's grid;
// the park page lists every facility card and is the right "what does this
// park have?" surface.

export default {
  buildBookingUrl({ site }) {
    return site.reserveUrl;
  },

  buildPreviewUrl(site, facility) {
    return facility?.extraAttributes?.parkUrl ?? site.reserveUrl;
  },

  describeBookingInputs() {
    return {
      inputs: {
        arrivalDate: {
          status: "ignored",
          notes:
            "The explore.ehawaii.gov SPA hash router takes no date params; users pick dates on the facility grid.",
        },
        departureDate: {
          status: "ignored",
          notes:
            "The explore.ehawaii.gov SPA hash router takes no date params; users pick dates on the facility grid.",
        },
        ref: {
          status: "ignored",
          notes: "site.reserveUrl already identifies the place + facility.",
        },
        partySize: {
          status: "ignored",
          defaultValue: 1,
          notes:
            "Party size (number of people, for the capacity facilities) is chosen in the booking flow after date selection.",
        },
      },
    };
  },
};
